var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_84_30013)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.7969 3.6443C9.7969 2.35195 10.8483 1.30055 12.1407 1.30055H12.9518L12.7071 0.620391C12.5695 0.237891 12.209 0 11.8249 0C11.7184 0 11.6101 0.0182812 11.5043 0.0568125L3.30804 3.03998C2.82078 3.21736 2.57 3.75656 2.7484 4.24345L3.18148 5.42555H9.7969V3.6443Z",
    fill: "#2F49D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2031 4.42579V3.70703H18.4062V4.42579H12.2031Z",
    fill: "#2F49D1",
    stroke: "#2F49D1",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8906 18.9492H18.6094C16.6709 18.9492 15.0938 17.3721 15.0938 15.4336C15.0938 13.4951 16.6709 11.918 18.6094 11.918H21.8906V8.70703C21.8906 7.67152 21.0511 6.83203 20.0156 6.83203H1.875C0.839484 6.83203 0 7.67152 0 8.70703V22.1252C0 23.1607 0.839484 24.0002 1.875 24.0002H20.0156C21.0511 24.0002 21.8906 23.1607 21.8906 22.1252V18.9492Z",
    fill: "#2F49D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2969 13.3242H18.6094C17.4463 13.3242 16.5 14.2705 16.5 15.4336C16.5 16.5967 17.4463 17.543 18.6094 17.543H23.2969C23.6846 17.543 24 17.2275 24 16.8398V14.0273C24 13.6396 23.6846 13.3242 23.2969 13.3242ZM18.6094 16.1367C18.2211 16.1367 17.9062 15.8219 17.9062 15.4336C17.9062 15.0453 18.2211 14.7305 18.6094 14.7305C18.9977 14.7305 19.3125 15.0453 19.3125 15.4336C19.3125 15.8219 18.9977 16.1367 18.6094 16.1367Z",
    fill: "#2F49D1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_84_30013"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.6425812d19f892ac4317f7466096e9d1.svg";
export { ForwardRef as ReactComponent };